module.exports = __webpack_public_path__ + "img/timer-primary.e882f330.svg";